import { createActions } from 'redux-actions';

const OPEN_MODAL = 'OPEN_MODAL';
const CLOSE_MODAL = 'CLOSE_MODAL';

const actionOptions = {
  prefix: 'app/modal',
};

export const actions = createActions(OPEN_MODAL, CLOSE_MODAL, actionOptions);
